import React from "react";
import { Box, Paper, Typography, TextField, Button, Link } from "@mui/material";
import AppShell from "./AppShell";
import usePageTitle from "../hooks/usePageTitle";

const Contact = () => {
  usePageTitle("Contact");
  return (
    <AppShell>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
          <Typography variant="h4" sx={{ mb: 2, fontWeight: "bold", color: "primary.main" }}>
            Connect With Us
          </Typography>

          <Typography variant="body1" sx={{ mb: 1 }}>
            Follow and join us on our platforms:
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Link
              href="https://www.instagram.com/thecollectorstop/"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{ fontWeight: 500 }}
            >
              Instagram - @thecollectorstop
            </Link>
            <Link
              href="https://discord.gg/2bbcbmcCS6"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{ fontWeight: 500 }}
            >
              Join our Discord Community
            </Link>
          </Box>
        </Paper>

        <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
          <Typography variant="h4" sx={{ mb: 2, fontWeight: "bold", color: "primary.main" }}>
            Contact Us via Email <Typography component="span" color="text.secondary">*Coming Soon*</Typography>
          </Typography>

          <Typography variant="body1" sx={{ mb: 4, color: "text.secondary" }}>
            We'd love to hear from you! Our email contact form will be launching shortly.
          </Typography>

          <Box
            component="form"
            noValidate
            autoComplete="off"
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              opacity: 0.5,
              pointerEvents: "none",
            }}
          >
            <TextField label="Email" variant="outlined" fullWidth required />
            <TextField label="Message" variant="outlined" fullWidth required multiline rows={4} />
            <Button variant="contained">Send Message</Button>
          </Box>
        </Paper>
      </Box>
    </AppShell>
  );
};

export default Contact;
